<div
  class="tab-launcher"
  [class.hovered]="isHovered()"
  (click)="handleClick()"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
  title="Request a compliance framework"
>
  <div class="tab-content">
    <span class="tab-text">Request Compliance Framework</span>
  </div>
</div>
